import React, { useState } from "react";
import {
  Bar,
  BarChart,
  CartesianAxis,
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  Flex,
  Heading,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";

const TotalEarningChart = ({ data, title }) => {
  const whiteBgColor = useColorModeValue("#fff", "#081b2e");

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const dataPoint = payload[0].payload; // Get the data point object
      const date = new Date(dataPoint.created_at);

      const dayOfWeek = date.toLocaleDateString("en-US", { weekday: "long" });
      const day = date.getDate();
      const month = date.toLocaleString("default", { month: "long" });
      const year = date.getFullYear();

      return (
        <div
          className="custom-tooltip"
          style={{
            backgroundColor: "white",
            padding: "5px",
            borderRadius: "5px",
          }}
        >
          <p className="label">{`Day: ${dayOfWeek}`}</p>
          <p className="label">{`Date: ${month} ${day}, ${year}`}</p>
          <p className="label">{`Amount: $${dataPoint.amount}`}</p>
        </div>
      );
    }

    return null;
  };

  // Calculate the maximum amount, let it be the highest YAxis value
  const maxAmount = Math.max(...data?.map((entry) => parseFloat(entry.amount)));

  const totalAmount = data?.reduce(
    (sum, entry) => sum + parseFloat(entry.amount),
    0
  );

  const formattedTotalSum = totalAmount > 0 ? formatAmount(totalAmount) : 0;

  function formatAmount(amount) {
    if (amount >= 1000000) {
      return (amount / 1000000).toFixed(1) + "m";
    } else if (amount >= 1000) {
      return (amount / 1000).toFixed(1) + "k";
    }
    return amount.toString();
  }

  const noDataStyles = {
    p: "10px",
    borderRadius: "5px",
    boxShadow: "3px 8px 13px 0px #8080800f",
    bg: whiteBgColor,
    w: "100%",
    fontSize: ".9em",
  };

  return (
    <>
      {data?.length > 0 ? (
        <Stack direction={"row"} mb="20px" justifyContent={"space-between"}>
          <Stack direction={"column"} gap={20}>
            <Heading fontSize="1.5em">
              {title ? title : "Total Earnings"}
            </Heading>

            <Heading>${formattedTotalSum}</Heading>
          </Stack>

          <ResponsiveContainer width="100%" height={400}>
            <LineChart
              data={data}
              margin={{
                top: 10,
                left: 20,
                right: 20,
                bottom: 10,
              }}
            >
              <CartesianGrid strokeDasharray="3 3"></CartesianGrid>
              <XAxis dataKey="created_at" tickFormatter={() => ""} />
              <YAxis domain={[0, maxAmount]} />
              <Tooltip content={<CustomTooltip />} />
              <Legend />
              <Line
                type="monotone"
                dataKey="amount"
                stroke="#4f46ba"
                strokeWidth={2}
              />
            </LineChart>
          </ResponsiveContainer>
        </Stack>
      ) : (
        <Stack
          direction={"column"}
          mb="20px"
          justifyContent={"center"}
          {...noDataStyles}
        >
          <Heading fontSize="1.5em">Total Earnings</Heading>

          <Text textAlign={"center"}>No data at the moment</Text>
        </Stack>
      )}
    </>
  );
};

export default TotalEarningChart;
